import CONTENTS from '@/api/contents';


const state = {
  Contents: {},
};

// mutations
const mutations = {

  Contents(state, Contents) {
    state.Contents = Contents;
  },

};


// getters
const getters = {

  Contents(state) {
    return state.Contents;
  },

};


// actions
const actions = {
  setContents({ commit, dispatch }) {
    return new Promise((resolve) => {
      CONTENTS.list().then((result) => {
        commit('contents/Contents', result.data, { root: true });
        resolve();
      });
    });
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
